(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("OpenTokNetworkConnectivity", [], factory);
	else if(typeof exports === 'object')
		exports["OpenTokNetworkConnectivity"] = factory();
	else
		root["OpenTokNetworkConnectivity"] = factory();
})(self, () => {
return 